import React from 'react'
import { FilterComponent } from '../../../components/_WMS/FilterComponent/FilterComponent'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { filterOptions } from './config'
import { FilterExtraAction } from '../../../components/_WMS/FilterComponent/types'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
  // Otras propiedades que puedas necesitar para tipos específicos
}

interface ComponentProps {}
interface WorkOrderOutboundSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  extraActions?: FilterExtraAction[]
  onAddButtonClick?: () => void
  addButtonTitle?: string
  createButtonTooltip?: string
}

export const WorkOrderOutboundSearch: React.FC<WorkOrderOutboundSearchProps> = (
  props
) => {
  return (
    <FilterComponent
      includeSearchOnClean={true}
      options={filterOptions}
      {...props}
      extraActions={props.extraActions}
    />
  )
}
